import React, { PureComponent } from 'react';
import Heading from './heading';

class HeadingBlock extends PureComponent {
    checkIsChinese(str) {
        //如果值为空，通过校验
        if (str === "")
        return true;

        var pattern = /^([\u4E00-\u9FA5]|[\uFE30-\uFFA0])*$/gi;
        if (pattern.test(str))
        return true;
        else
        return false;
    }
    checkEng(num) {
        var reg = /^[A-Za-z]+$/;
        return reg.test(num)
    }
    lowerCase(str) {
        let arr = str.split("");
        let newStr = "";
        //通过for循环遍历数组
        for (let i = 0; i < arr.length; i++) {
            if (arr[i] >= 'A' && arr[i] <= 'Z')
                newStr += arr[i].toLowerCase();
            else
                newStr += arr[i];
        }
        return newStr;
    }
    upperToLower(string) {
        const array = string.split(' ')
        const newArray = array.map(item => {
            item = this.lowerCase(item)
            if (item.indexOf('（') > 0) {
                item = item.replace('（', '')
            }
            if (item.indexOf('）') > 0) {
                item = item.replace('）', '')
            }
            if (item.indexOf('(') > 0) {
                item = item.replace('(', '')
            }
            if (item.indexOf(')') > 0) {
                item = item.replace(')', '')
            }
            if (item.indexOf('&') > 0) {
                item = item.replace('&', '')
            }
            if (this.checkEng(item)) {
                return item.toLowerCase()
            }
            else {
                return item
            }
        })
        return newArray.join('-')
    }
    renderHtml = () => {
        const { level, children } = this.props;
        if (children && children.length > 0) {
            const nodeValue = children[0].props.value;
            let firstNodeValue, secondNodeValue
            if (nodeValue.indexOf('.') > 0) {
                firstNodeValue = nodeValue.split('.').join('')
            } else {
                firstNodeValue = nodeValue
            }
            if (typeof firstNodeValue === 'string' && firstNodeValue.indexOf(' ') > 0) {
                secondNodeValue = this.upperToLower(firstNodeValue)
            }
            // console.log(nodeValue, firstNodeValue, secondNodeValue, 'nodeValue')
            return (
                <Heading level={`h${level}`}>
                    <span className="title">
                        {children}
                        <div id={secondNodeValue} style={{position: 'relative', top: '-95px'}}></div>
                    </span>
                </Heading>
            )
        } else {
            return <>{children}</>;
        }
    };
    render() {
        return <>{this.renderHtml()}</>;
    }
}

export default HeadingBlock